import {Message, Spin} from 'view-design'
import {getToken} from '@/libs';
import axios from "axios";
import router from "@/router";

const SUCCESS = 200
const AUTH_ERR = 401 //令牌错误

const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_URL : ""
});

// 添加请求拦截器
instance.interceptors.request.use((config) => {
  // 在发送请求之前做些什么
  showLoading(config);
  if (config.headers) {
    config.headers['dg-admin'] = 'company';
    config.headers['token'] = getToken() || '';
  }
  return config;
}, (error) => {
  // 对请求错误做些什么
  hideLoading(error);
  Message.error('请求异常!');
  return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use((response) => {
  // 2xx 范围内的状态码都会触发该函数。
  // 对响应数据做点什么
  hideLoading(response);
  let res = response.data;
  return new Promise((resolve, reject) => {
    if (res.code !== SUCCESS) {
      if (res.code == AUTH_ERR) {//无token
        router.push('/login');
      } else {
        Message.error(res.info);
      }
      reject(res.info);
    } else {
      resolve(res);
    }
  })
}, (error) => {
  // 超出 2xx 范围的状态码都会触发该函数。
  // 对响应错误做点什么
  hideLoading(error);
  Message.error('服务异常!');
  return Promise.reject(error);
});

const showLoading = (config) => {
  if (config.isLoad) {
    Spin.show();
  }
}
const hideLoading = (response) => {
  if (response.config.isLoad) {
    Spin.hide();
  }
}

const get = (url, params = {}, isLoad = true) => {
  return new Promise((resolve, reject) => {
    instance.get(url, {
      params,
      isLoad
    }).then(res => {
      resolve(res);
    }).catch(err => {
      reject(err)
    })
  });
}

const post = (url, data, isLoad = true) => {
  return new Promise((resolve, reject) => {
    instance.post(url, data, {isLoad}).then(res => {
      resolve(res);
    }).catch(err => {
      reject(err)
    })
  });
}

export default {
  get,
  post
}
